import {
  BUDGET_QUESTION_ID,
  FEATURE_QUESTION_ID,
} from "../constants/questionIds";

export function collectResponsesSeparate() {
  return this.children.map((childQuestion, _) => {
    return {
      question: this.children.length <= 1 ? this.viewText : childQuestion.text,
      selectedOptions: childQuestion.responses
        ? childQuestion.responses.call(childQuestion)
        : childQuestion.options
            ?.filter((opt) => opt.selected)
            .map((opt) => opt.text.replace(/^[^a-zA-Z0-9]+/, "")) || [],
      ...(childQuestion.inputCondition
        ? { inputValue: childQuestion.inputValue }
        : {}),
      questionId: childQuestion.childQuestionId,
    };
  });
}

export function collectResponsesAggregated() {
  return {
    question: this.viewText,
    selectedOptions: this.children.flatMap((childQuestion, _) => {
      return childQuestion.options
        ? childQuestion.options
            .filter((opt) => opt.selected)
            .map((opt) => opt.text.replace(/^[^a-zA-Z0-9]+/, ""))
        : [];
    }),
    inputValue:
      this.children.find(
        (childQuestion) => childQuestion.inputValue?.length > 0
      )?.inputValue || "",
    questionId: this.questionId,
  };
}

export function updatedProfileResponses() {
  return this.children.map((childQuestion, _) => {
    return childQuestion.childQuestionId === BUDGET_QUESTION_ID &&
      childQuestion.currSelected.length > 0
      ? {
          question: childQuestion.text,
          selectedOptions:
            childQuestion.currSelected.length > 0
              ? [
                  ...childQuestion.currSelected,
                  childQuestion.monthlyBudget ? "monthly" : "range",
                ]
              : [],
          questionId: childQuestion.childQuestionId,
        }
      : childQuestion.childQuestionId === FEATURE_QUESTION_ID &&
          childQuestion.currSelected.length > 0
        ? {
            question: "What are some of your must-have features?",
            selectedOptions: (() => {
              const featureOptions = {};
              childQuestion.options.forEach((option) => {
                if (option.featureKey) {
                  featureOptions[option.featureKey] = option.selected;
                }
              });
              return [featureOptions];
            })(),
            questionId: childQuestion.childQuestionId,
          }
        : {
            question: childQuestion.text,
            selectedOptions:
              childQuestion.options
                ?.filter((opt) => opt.selected)
                .map((opt) => opt.text.replace(/^[^a-zA-Z0-9]+/, "")) || [],
            ...(childQuestion.inputCondition
              ? { inputValue: childQuestion.inputValue }
              : {}),
            questionId: childQuestion.childQuestionId,
          };
  });
}
